const apiRoutes = {
  production: {
    aioCore: "https://aio-core-admin.de-2.nsoft.cloud",
    bets: "https://aio-bet-list-rest.de-2.nsoft.cloud",
    betslip: "https://aio-betslip-rest.de-2.nsoft.cloud",
    limits: "https://aio-limit-rest.de-2.nsoft.cloud",
    tc: "https://frasier.de-2.nsoft.cloud",
    tenant: "https://sxg-int-tenant-manager.de-2.nsoft.cloud",
    guards: "https://int-sxg-guards.de-2.nsoft.cloud",
    offerDistribution: "https://aio-offer-distribution.de-2.nsoft.cloud",
    customBet: "https://aio-custom-bet-rest.de-2.nsoft.cloud",
    liability: "https://aio-liability-rest.de-2.nsoft.cloud",
    feedMappings: "https://aio-core-mapping-service.de-2.nsoft.cloud",
    tagEngine: "https://int-tag-engine.de-2.nsoft.cloud",
    authorizationDistribution: "wss://aio-manual-authorization-distribution.de-2.nsoft.cloud",
    manualAuthorization: "https://aio-manual-authorization.de-2.nsoft.cloud",
    clientProxy: "https://aio-client-proxy.de-2.nsoft.cloud",
    printedOffer: "https://sports-aio-printed-offer.nsoft.cloud",
  },
  staging: {
    aioCore: "https://aio-core-admin.staging.de-2.nsoft.cloud",
    bets: "https://aio-bet-list-rest.staging.de-2.nsoft.cloud",
    betslip: "https://aio-betslip-rest.staging.de-2.nsoft.cloud",
    limits: "https://aio-limit-rest.staging.de-2.nsoft.cloud",
    tc: "https://frasier.de-2.nsoft.cloud",
    tenant: "https://int-sxg-tenant-manager.staging.de-2.nsoft.cloud",
    guards: "https://int-sxg-guards.staging.de-2.nsoft.cloud",
    offerDistribution: "https://aio-offer-distribution.staging.de-2.nsoft.cloud",
    customBet: "https://aio-custom-bet-rest.staging.de-2.nsoft.cloud",
    liability: "https://aio-liability-rest.staging.de-2.nsoft.cloud",
    feedMappings: "https://aio-core-mapping-service.staging.de-2.nsoft.cloud",
    tagEngine: "https://int-sxg-tag-engine.staging.de-2.nsoft.cloud",
    authorizationDistribution:
      "wss://aio-manual-authorization-distribution.staging.de-2.nsoft.cloud",
    manualAuthorization: "https://aio-manual-authorization.staging.de-2.nsoft.cloud",
    clientProxy: "https://aio-client-proxy.staging.de-2.nsoft.cloud",
    printedOffer: "https://sports-aio-printed-offer.nsoft.app",
  },
};

export default apiRoutes[appEnvironment] ?? apiRoutes.staging;
